const KEY_FIRST = "fda_first_touch";
const KEY_LAST = "fda_last_touch";

function currentTouch() {
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source"),
    utm_medium: p.get("utm_medium"),
    utm_campaign: p.get("utm_campaign"),
    utm_content: p.get("utm_content"),
    utm_term: p.get("utm_term"),
    fbclid: p.get("fbclid"),
    landing_page: window.location.pathname + window.location.search,
    referrer: document.referrer || null,
    captured_at: new Date().toISOString(),
  };
}

export function captureAttribution() {
  const t = currentTouch();
  const hasUtm = t.utm_source || t.utm_campaign || t.fbclid;
  if (!localStorage.getItem(KEY_FIRST)) localStorage.setItem(KEY_FIRST, JSON.stringify(t));
  if (hasUtm || !localStorage.getItem(KEY_LAST)) localStorage.setItem(KEY_LAST, JSON.stringify(t));
}

export function getAttribution() {
  const first = JSON.parse(localStorage.getItem(KEY_FIRST) || "null") || currentTouch();
  const last = JSON.parse(localStorage.getItem(KEY_LAST) || "null") || first;
  return {
    ...last,
    first_touch: JSON.stringify(first),
    last_touch: JSON.stringify(last),
  };
}
